import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the signupParent state domain
 */

const selectSignupParentDomain = state => state.signupParent || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by SignupParent
 */

const selectSignupParentData = () =>
  createSelector(
    selectSignupParentDomain,
    substate => substate.signupParentData,
  );

const selectSignupParentList = () =>
  createSelector(
    selectSignupParentDomain,
    substate => substate.signupParentList,
  );

const selectSignupParentLoading = () =>
  createSelector(
    selectSignupParentDomain,
    substate => substate.loading,
  );

const selectSignupParentError = () =>
  createSelector(
    selectSignupParentDomain,
    substate => substate.error,
  );

const selectSignupParentDeleteSuccessful = () =>
  createSelector(
    selectSignupParentDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectSignupParentDomain,
  selectSignupParentLoading,
  selectSignupParentError,
  selectSignupParentDeleteSuccessful,
  selectSignupParentData,
  selectSignupParentList,
};
